
<template>
    <div>
      <div class="ranking">{{rank + 1 + index}}.</div>
      <div class="name">{{partnerDisplayName(item)}}</div>
      <BadgeIcons :champion="item.champion" :diamond="item.diamond" :award="item.award" />
      <div class="compliance" :class="getItemComplianceClass(item.compliance)">{{formatCompliance(item.compliance)}}</div>
      <div class="revenue-today">&euro;{{formatFee(item.fee_partner_today)}}</div>
      <div class="revenue-week">&euro;{{formatFee(item.fee_partner_this_week)}}</div>
      <div class="revenue-quarter">&euro;{{formatFee(item.fee_partner_this_quarter)}}</div>
    </div>
</template>

<script>
// import shared from '../shared/shared.js';
// import { useStore } from 'vuex'
import Mixin from '../shared/mixin';
import BadgeIcons from './BadgeIcons.vue';

export default {
  name: 'PartnerList',
  components: { BadgeIcons },
  props: [
    'item','rank','toggle','index'
  ],
  mixins: [Mixin],
  setup() {
  }
};

</script>